import React from "react";

const DropdownValues = (props) => {
  return (
    <>
      {props.labelname}
      <select
        value={props.selectoption}
        onClick={props.onClick}
        onChange={props.onChange}
        disabled={props.disabled}
        className={props.className}
      >
        {props.Displayname && <option value="">{props.Displayname}</option>}
        {props.options?.length > 0 ? (
          props.options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.display}
            </option>
          ))
        ) : (
          <option value="">No Options Avaliable</option>
        )}
      </select>
    </>
  );
};
export default DropdownValues;
